var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"funding-wallet"},[_c('fundind-wallet',{on:{"sucsessFunding":_vm.sucsessFunding,"closeFunding":_vm.closeFunding}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }